module.exports = __webpack_public_path__ + "img/zgnyyh.dce8f2b2.png";